import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpApiService} from './http-api.service';

@Injectable({
  providedIn: 'root'
})
export class SearchApiService {
  private readonly searchByTermEndpoint = 'search/';

  constructor(private httpApiService: HttpApiService) {
  }

  public searchByTerm(cookies: string, params: any): Observable<any> {
    return this.httpApiService.get<any>(this.searchByTermEndpoint, params, cookies);
  }
}
